import React from 'react'
import classnames from 'classnames'
import { Link } from 'react-router-dom'
import { conditionalLink } from '../../conditional-link'

const SessionSummary = ({ record, path, selected = false }) => (
  <div
    className={classnames({
      listItemContent: true,
      inactiveRecord: record.inactive,
    })}>
    {conditionalLink(
      !selected,
      <Link to={path}>
        <div className="listItemContent--heading">
          {record.child.first_name} {record.child.last_name}
        </div>
      </Link>
    )}
  </div>
)

export default SessionSummary



// WEBPACK FOOTER //
// ./src/session-summaries/views/index.jsx